<template>
  <v-container>
    <v-data-table-server
      v-model:items-per-page="pagination.limit"
      :items="branches"
      :headers="headers"
      :items-length="count"
      :loading="loading"
      :search="pagination.q"
      item-key="id"
      @update:options="handleLimitChange">
      <template v-slot:[`item.action`]="{ item }">
        <v-btn
          :to="{ name: editPath, params: { branchId: item.id, ...additionalParams } }"
          router
          small
          color="primary">
          Edit
        </v-btn>
      </template>
      <template v-slot:top>
        <v-text-field
          v-model="pagination.q"
          class="ma-2"
          density="compact"
          placeholder="Search branch..."
          hide-details></v-text-field>
      </template>
    </v-data-table-server>
  </v-container>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from 'vue';
import { IPaginationDTO, PaginationDTO } from '@/dtos';
import type { VDataTableServer } from 'vuetify/components';
import { RouteParamsRawGeneric } from 'vue-router';
import { useBranchStore } from '@/stores/modules/admin';

interface Props {
  editPath: string;
  additionalParams?: RouteParamsRawGeneric;
}
const props = defineProps<Props>();
const branchStore = useBranchStore();
const branches = computed(() => branchStore.getAllBranchesQuery.data?.data ?? []);
const loading = computed(() => branchStore.getAllBranchesQuery.isLoading);
const count = computed(() => branchStore.getAllBranchesQuery.data?.count ?? 0);

const editPath = toRef(props, 'editPath', '');
const additionalParams = computed(() => props.additionalParams ?? {});
const headers = [
  { title: 'Branch', key: 'name' },
  { title: 'City', key: 'city' },
  { title: 'State', key: 'state' },
  { title: 'Edit', key: 'action' },
];

const pagination = ref<IPaginationDTO>(new PaginationDTO());

const handleLimitChange = (value: VDataTableServer) => {
  pagination.value.buildPagination(value);
  branchStore.pagination = pagination.value;
};
</script>

<style scoped></style>
